export default __webpack_public_path__ + "static/media/Timeline-GiftBoxes-24.2692e2f2.png";